module.exports = __webpack_public_path__ + "img/enterprise-4.c68edb18.png";